
import { communicationsApi } from '@app/services'

import { FetchParticipantResponse } from './types'

export const fetchConversationParticipant = async (
  conversationId: number,
  participantId: number
) => {
  const { data } = await communicationsApi.get<FetchParticipantResponse>(
    `conversation/${conversationId}/participants/${participantId}`
  )

  return data
}
